"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useParentScroll = useParentScroll;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _react = require("react");
var _popperUtils = require("../popperUtils");
function useParentScroll(elementRef, onScroll) {
  (0, _react.useEffect)(function () {
    if (!elementRef.current || !onScroll) {
      return function () {
        return null;
      };
    }
    var dom = elementRef.current;

    // https://github.com/FezVrasta/popper.js/blob/master/packages/popper/src/utils/setupEventListeners.js
    var scrollParents;
    var scrollParent;
    scrollParents = [];
    scrollParent = (0, _popperUtils.getScrollParent)(dom);
    function handleScroll(event) {
      // IE 元素内部滚动会冒泡至 window
      // 导致非 scrollParent 元素滚动触发 onScroll
      if (event.target === event.currentTarget) {
        onScroll(event);
      }
    }
    while (scrollParent) {
      var isBody = scrollParent.nodeName === 'BODY';
      var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
      if (target != null) {
        target.addEventListener('scroll', handleScroll, {
          passive: true
        });
        scrollParents.push(target);
      }
      if (isBody) {
        break;
      }
      scrollParent = (0, _popperUtils.getScrollParent)((0, _popperUtils.getParentNode)(scrollParent));
    }
    scrollParent = null;
    return function () {
      if (scrollParents != null) {
        scrollParents.forEach(function (parent) {
          return parent.removeEventListener('scroll', handleScroll);
        });
      }
      scrollParents = null;
    };
  }, [Boolean(onScroll), elementRef.current]);
}